
import { Vue, Component, Prop, Model, Watch} from "vue-property-decorator";

import UiButton from "@/components/button/ui-button.vue";
import CREATE_GROUP_CONVERSATION from "@/apollo/conversations/CreateGroupConversation.gql";
import FormGroup from "@/components/form/FormGroup.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import Checkbox from "@/components/form/Checkbox.vue";
import RouteNames from "@/entities/RouteNames";
import { Conversation } from "@/interface";
import GroupConversationUser from "@/entities/GroupConversationUser";

@Component({
  components: {
    UiButton,
    FormGroup,
    CircleWithInitials,
    ModalFullScreen,
    Checkbox,
  },
})
export default class CreateGroupConversationModal extends Vue {
  @Model("toggle", { type: Boolean, default: false }) readonly isOpen!: boolean;
  @Prop({ type: String, default: undefined }) readonly currentUserId?: string;
  @Prop({ type: String, default: undefined }) readonly companyId?: string;
  @Prop({ type: String, default: undefined }) readonly projectTitle?: string;
  @Prop({ type: Array, default: () => [] }) readonly groupConversationUsers!: GroupConversationUser[];

  checkboxOptions: GroupConversationUser[] = [];

  @Watch("groupConversationUsers", {immediate: true})
  onConversationUsersChange(users: GroupConversationUser[]): void {
    this.checkboxOptions = users
      .map((user) => ({
        ...user,
        selected: true,
    }));
  }

  createdConversation: Conversation | null = null;
  conversationName: string | null = null;

  get selectedUsers(): string[] {
    return this.checkboxOptions
      .filter(user => user.selected)
      .map(user => user.userId);
  }

  handleClose(): void {
    this.checkboxOptions = this.checkboxOptions.map(user => ({
      ...user,
      selected: true,
    }));
    this.$emit('toggle', false);
  }

  async createGroupConversation(): Promise<void> {
    this.createdConversation = await this._createGroupConversation();
    this.$router.push({
      name: RouteNames.INBOX_CONVERSATION,
      params: {
        conversationId: this.createdConversation.id,
      },
    });
  }

  async _createGroupConversation(): Promise<Conversation> {
    const usersInput = this.selectedUsers.map( userId => {
      return {
        user_id: userId,
      };
    })

    const currentUserIsPresent = usersInput
    .some(userInput => userInput.user_id === this.currentUserId);

    if (this.currentUserId && !currentUserIsPresent) {
      usersInput.push({user_id: this.currentUserId});
    }

    const mutationData = {
      name: this.conversationName,
      users: {
        data: usersInput
      }   
    };

    const created = await this.$apollo.mutate({
      mutation: CREATE_GROUP_CONVERSATION,
      variables: { mutationData }
    });
    
    return created.data.insert_conversation_one;
  }
}
